import React from 'react';
import { BaseModal } from 'components/UI';
import { VehiclesGroupsSelect } from 'components/AsyncFields';
import { Formik, Field } from 'formik';
import * as Yup from 'yup';
import Box from '@material-ui/core/Box';
import i18n from 'i18n-js';
import { VehicleGroupsLabel } from 'components/VehiclesGroups';

const formSchema = Yup.object().shape({
  vehicle_group_id: Yup.string().required('This field is required'),
});

function EditAssignedGroupModal({
  open,
  isOwner,
  loading,
  onCancel,
  onConfirm,
  params = {},
  vehicleGroupId,
}) {
  const group_type = isOwner ? 'OWNER' : 'CUSTOMER';
  const formRef = React.useRef(null);

  return (
    <BaseModal
      open={open}
      hasEnterButton
      hasCancelButton
      loading={loading}
      onEnter={() => {
        formRef.current.submitForm();
      }}
      onCancel={onCancel}
      enableCloseButton={false}
      enterButtonLabel={i18n.t('common.edit')}
      aria-labelledby="modal-title"
      title={`${i18n.t('common.edit')} ${VehicleGroupsLabel()}`}
      size="sm"
      data-cy="edit-assigned-group-modal"
    >
      <Box mt={-1}>
        <Formik
          innerRef={formRef}
          initialValues={{ vehicle_group_id: vehicleGroupId || '' }}
          validationSchema={formSchema}
          onSubmit={(values) => onConfirm(values.vehicle_group_id)}
        >
          <Field
            name="vehicle_group_id"
            component={VehiclesGroupsSelect}
            customParams={{ group_type, ...params }}
            label={VehicleGroupsLabel()}
          />
        </Formik>
      </Box>
    </BaseModal>
  );
}

export default EditAssignedGroupModal;
